export const PREVIEWABLE_ATTACHMENT_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,.bmp,.svg,.pdf,.docx,.xlsx'

export const PREVIEWABLE_ATTACHMENT_ACCEPT_LABEL = '图片、PDF、Word(docx)、Excel(xlsx)'

function parseAcceptRules(accept) {
  return String(accept || PREVIEWABLE_ATTACHMENT_ACCEPT)
    .split(',')
    .map(rule => rule.trim())
    .filter(Boolean)
}

export function isPreviewableAttachmentFile(file, accept = PREVIEWABLE_ATTACHMENT_ACCEPT) {
  if (!file) return false
  const rules = parseAcceptRules(accept)
  if (!rules.length || rules.includes('*/*')) return true

  const fileName = String(file.name || file.fileName || file.originalName || '').toLowerCase()
  const contentType = String(file.type || file.contentType || '').toLowerCase()

  return rules.some(rule => {
    const normalizedRule = rule.toLowerCase()
    if (normalizedRule.startsWith('.')) {
      return fileName.endsWith(normalizedRule)
    }
    if (normalizedRule.endsWith('/*')) {
      return contentType.startsWith(normalizedRule.slice(0, -1))
    }
    return contentType === normalizedRule
  })
}
